import React from 'react'

class Unavailable extends React.Component {
  render () {
    return (
      <div>
        <h1>Access Denied</h1>
        <p>Please e-mail <a href='mailto:info@maatsapp.com'>info@maatsapp.com</a> to upgrade your service.</p>
      </div>
    )
  }
}

export default Unavailable



// WEBPACK FOOTER //
// ./src/components/unavailable.js